import { render } from "./ProjectSummaryCredits.vue?vue&type=template&id=3c3514e5"
import script from "./ProjectSummaryCredits.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryCredits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__